const revenueByPDI = (revenues: any) => {
  let data: any = [];
  const result = revenues.filter((revenue: any) => revenue._id === "PDI")[0];
  const pdi = result === undefined ? [] : result;

  pdi?.list?.forEach((item: any) => {
    item?.list?.forEach((item: any) => {
      data.push(item);
    });
  });

  return { pdi, data };
};

export default revenueByPDI;
